import $ from 'jquery';
import {store} from 'store2';
import {is_boolean} from '../../../Helpers/js/simple.functions';

$.initialize('[data-role="togglebox"]', function () {
    $(this).togglebox();
});
$.widget('lp.togglebox', {

    $content: null,
    $trigger: null,
    icons: {},
    historyId: null,

    _create: function () {
        var that = this;

        this.$trigger = this.element.find('[data-role="togglebox-trigger"]').first();
        this.$content = this.element.find('>[data-role="togglebox-content"]');
        this.icons = {
            hidden: this.$trigger.data('hidden-icon'),
            visible: this.$trigger.data('visible-icon')
        };

        this._setTriggerIcon();
        this.element.find('.togglebox-label').css('cursor', 'pointer');

        this.$trigger.on('click', function (e) {
            that.toggle();
            e.stopPropagation();
            return false;
        });

        let initState = this.element.data('togglebox-initstate') == 'open';
        let histId = this.element.data('togglebox-history-id');
        if (histId) {
            this.store = store.namespace(`tglbx-${histId}`);
            let state = this.store.get('state');
            if (!is_boolean(state)) {
                state = initState;
            }

            state ? this.open(true) : this.close(true);
        }
    },

    open: function (fast) {
        this.store && this.store.set('state', true);

        fast === true ? this.$content.show() : this.$content.slideDown(250);
        this._setTriggerIcon(true);

        if (this.$trigger.data('visible-text')) {
            var visibleText = this.$trigger.data('visible-text');
            this.$trigger.text(visibleText); //HIDE_MORE_RESULTS
        }
    },

    close: function (fast) {
        this.store && this.store.set('state', false);
        fast === true ? this.$content.hide() : this.$content.slideUp(250);

        this._setTriggerIcon(false);

        if (this.$trigger.data('hidden-text')) {
            var hiddenText = this.$trigger.data('hidden-text');
            this.$trigger.text(hiddenText); //SHOW_MORE_RESULTS
        }

    },

    toggle: function () {
        if (this.$content.is(':visible')) {
            this.close();
        } else {
            this.open();
        }
    },

    _setTriggerIcon: function (state) {
        var open;
        if (typeof state !== 'undefined') {
            open = state ? true : false;
        } else {
            open = this.$content.is(':visible');
        }

        if (open) {
            this.element.find('[data-role="togglebox-icon"]').first().removeClass(this.icons.hidden).addClass(this.icons.visible);
        } else {
            this.element.find('[data-role="togglebox-icon"]').first().removeClass(this.icons.visible).addClass(this.icons.hidden);
        }
    }
});

